module.exports = __webpack_public_path__ + "static/media/05-quote-01-tane@2x.2329fb3f.jpg";